export default "__VITE_ASSET__CF8K5syJ__"